const selectGroupKey = "ElSelectGroup";
const selectKey = "ElSelect";

export { selectGroupKey, selectKey };
//# sourceMappingURL=token.mjs.map
